import React, { useState } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Sidebar from "./pages/nav/sidebar";
import "bootstrap-icons/font/bootstrap-icons.css";
import Container from "react-bootstrap/Container";
import CustomNavbar from "./pages/nav/customNavbar.js";
import { Row, Col } from "react-bootstrap";
import { TokenProvider } from "./scripts/tokenContext";
import AppRoutes from "./AppRoutes"; // Import the routes
import { DateProvider } from "./scripts/dateContext.js";

function MainContent() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();

  const toggleSidebar = () => {
    setSidebarOpen((prevSidebarOpen) => !prevSidebarOpen);
  };

  const isLoginPage = location.pathname.startsWith("/login");

  return (
    <Container fluid>
      {!isLoginPage && <CustomNavbar sidebarOpen={sidebarOpen} />}
      <Row className="containerConteudo">
        {!isLoginPage && (
          <Sidebar toggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
        )}
        <Col
          className={`tabela-scroll content ${sidebarOpen ? "expanded" : ""}`}
        >
          <AppRoutes /> {/* Replace routes with AppRoutes */}
        </Col>
      </Row>
    </Container>
  );
}

export function App() {
  return (
    <Router>
      <TokenProvider>
        <DateProvider>
          <div className="App">
            <MainContent />
          </div>
        </DateProvider>
      </TokenProvider>
    </Router>
  );
}

export default App;
